import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";

import "./i18n";
import "./styles/index.css";

if (
  import.meta.env.PROD &&
  import.meta.env.VITE_ENABLE_SENTRY === "true" &&
  import.meta.env.VITE_SENTRY_DSN
) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ["error", "warn"] }),
    ],
    // LogRocket emits a console.warn when the session quota is exceeded. Since
    // captureConsoleIntegration forwards console.warn to Sentry, filter these
    // out to avoid noise from a known, non-actionable condition.
    ignoreErrors: [/LogRocket: Session quota exceeded/],
    tracesSampleRate: 0.001,
  });
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
